module.exports = __webpack_public_path__ + "img/Picture16.916b6822.jpg";